import React from "react";
import { styled } from "@mui/material/styles";
import FullLogo from "../../../../Full.logo.navy.png";
import Navigation from "./components/Navigation";
import QuickStats from "./components/QuickStats";

const SideBar = ({ userId }) => {
  return (
    <SidebarShell>
      <BrandPanel>
        <LogoFrame>
          <img src={FullLogo} alt="Lancaster Logo" />
        </LogoFrame>
      </BrandPanel>

      <Navigation userId={userId} />

      <QuickStats />
    </SidebarShell>
  );
};

const SidebarShell = styled("aside")({
  width: "100%",
  height: "100%",
  gridRow: "1 / 4",
  gridColumn: 1,
  display: "grid",
  gridTemplateRows: "8.2rem minmax(0, 1fr) minmax(18rem, 22rem)",
  background:
    "linear-gradient(180deg, #f3f6fa 0%, #e8eef5 48%, #dfe7f0 100%)",
  borderRight: "0.1rem solid rgba(120,139,158,0.28)",
  boxShadow: "0.6rem 0 2.2rem rgba(71,85,105,0.1)",
  zIndex: 100,
  overflow: "hidden",
});

const BrandPanel = styled("header")({
  gridRow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "1.2rem 1.3rem",
  borderBottom: "0.1rem solid rgba(120,139,158,0.24)",
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.76), rgba(255,255,255,0.42))",
});

const LogoFrame = styled("div")({
  width: "100%",
  height: "100%",
  borderRadius: "0.8rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(255,255,255,0.62)",
  border: "0.1rem solid rgba(120,139,158,0.22)",
  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.55)",

  "& img": {
    width: "88%",
    height: "auto",
    display: "block",
  },
});

export default SideBar;